import { Button, Divider, Input, Pagination, Select } from "antd";
import IndustrialParkCard from "@/pages/home/section/IndustrialSection/components/IndustrialParkCard";
import { useEffect, useState } from "react";
import IndustrialService from "@/services/IndustrialService";
import PropertiesService from "@/services/PropertiesService";
import { SearchIcon } from "lucide-react";
import { EmptyComponent } from "@/components/ui/EmptyComponent";

export const IndustrialSectionIndex = () => {
    const [industrials, setIndustrials] = useState([]);
    const ITEM_PER_PAGE = 6;
    const [currentPage, setCurrentPage] = useState(0);
    const [loading, setLoading] = useState(false);
    // search
    const [provinces, setProvinces] = useState([]);
    const [filterProvinces, setFilterProvinces] = useState('');
    const [filterIndustrials, setFilterIndustrials] = useState([]);
    const [side, setSide] = useState('');
    const [query, setQuery] = useState({});

    const sides = [
        { value: '', label: 'Tất cả miền' },
        { value: 'B', label: 'Miền Bắc' },
        { value: 'T', label: 'Miền Trung' },
        { value: 'N', label: 'Miền Nam' },
    ]
    const handleSearch = () => {
        const temp = {}
        if (filterProvinces !== '') {
            temp.codeTinh = filterProvinces;
        }
        if (side !== '') {
            temp.codeKhuVuc = side;
        }

        setQuery(temp);
        setLoading(true);
    }
    useEffect(() => {
        PropertiesService.getFilter({ ParentCode: 'J003' }).then(data => {
            setProvinces([{
                Code: '',
                Name: 'Tất cả tỉnh thành'
            }, ...data.Data])
        })
    }, []);

    useEffect(() => {
        IndustrialService.getIndustrialUrgent(query).then((res) => {
            setIndustrials(res.Data)
            setFilterIndustrials(res.Data)
            setLoading(false)
        })
    }, [query, currentPage]);

    const page = filterIndustrials.slice(currentPage * ITEM_PER_PAGE, (currentPage + 1) * ITEM_PER_PAGE);
    return (
        <div className={"p-4 min-h-[600px] space-y-2"}>
            <div className={"mb-4 h-full"}>
                <Divider
                    className="font-bold uppercase w-full"
                    style={{ borderColor: "#7cb305" }}
                    align="center"
                    orientation="center"
                >
                    <h1 className="lg:text-3xl text-md font-bold text-green-700">
                        Tìm kiếm công việc theo khu công nghiệp
                    </h1>
                    <p className="lg:text-sm text-xs text-gray-500">
                        Những công việc, công ty theo khu công nghiệp được lựa chọn nhiều nhất
                    </p>
                </Divider>
            </div>
            <div
                style={{
                    backgroundSize: "200% 200%",
                    animation: "gradient-animation 6s ease infinite",
                }}
                className={"bg-gradient-to-l from-green-200 to-green-800 transition-all w-fit rounded-md shadow-md justify-center flex mx-auto p-2 mb-4"}>
                <div className={"items-center flex flex-wrap gap-2"}>
                    <Select
                        className={"w-36"}
                        size={'middle'}
                        options={sides}
                        value={side}
                        onChange={(e) => setSide(e)}
                    />
                    <Select
                        showSearch
                        optionFilterProp={'Name'}
                        className={"w-48"}
                        size={'middle'}
                        options={provinces}
                        value={filterProvinces}
                        fieldNames={{ value: 'Code', label: 'Name' }}
                        onChange={(e) => setFilterProvinces(e)}
                    />
                    <Button type={"primary"}
                        onClick={handleSearch}
                        className={"w-fit font-bold"}>
                        {loading ? 'Đang tìm kiếm' : 'Tìm kiếm'}
                    </Button>
                </div>
            </div>
            <div className={"grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"}>
                {page.length === 0 ?
                    <div className={"col-span-3"}>
                        <EmptyComponent description={"khu công nghiệp"} />
                    </div>

                    : page.map((industrial, index) => (
                        <IndustrialParkCard key={index} data={industrial} />
                    ))
                }
            </div>
            <Pagination
                className={"mt-8 flex justify-center space-x-4"}
                align="center"
                onChange={(page) => setCurrentPage(page)}
                current={currentPage}
                total={filterIndustrials.length}
                pageSize={ITEM_PER_PAGE}
                showSizeChanger={false}
                showQuickJumper={false}
            />
        </div>
    )
}